import { result } from 'lodash/fp';

const getFromWindow =
    (context: string) =>
    (prop: string, defaultValue: number | string | boolean = ''): $TSFixMe =>
        result([context, prop], window) || defaultValue;

const getFromScreen = getFromWindow('screen');
const getFromNavigator = getFromWindow('navigator');

const getBrowserInfo = () => {
    const currentDate = new Date();

    return {
        screenWidth: getFromScreen('width', 0),
        screenHeight: getFromScreen('height', 0),
        colorDepth: getFromScreen('colorDepth', 0),
        userAgent: getFromNavigator('userAgent'),
        language: getFromNavigator('language'),
        javaEnabled: getFromNavigator('javaEnabled', false),
        timeZoneOffset: currentDate.getTimezoneOffset(),
    };
};

export default getBrowserInfo;
